import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

function UserCard(props) {
  var avatar = props.avatar,
      profileURL = props.profileURL,
      large = props.large,
      initials = props.initials,
      id = props.id,
      _props$displayName = props.displayName,
      displayName = _props$displayName === void 0 ? 'Username' : _props$displayName,
      _props$isLiu = props.isLiu,
      isLiu = _props$isLiu === void 0 ? false : _props$isLiu,
      _props$avatarErr = props.avatarErr,
      avatarErr = _props$avatarErr === void 0 ? false : _props$avatarErr,
      _props$onAvatarErr = props.onAvatarErr,
      onAvatarErr = _props$onAvatarErr === void 0 ? noop : _props$onAvatarErr;
  var showAvatar = Boolean(avatar && !avatarErr);
  var avatarImg = null;
  var avatarType = 'default';

  if (showAvatar) {
    avatarType = 'image';
    avatarImg = /*#__PURE__*/React.createElement("img", {
      className: "user-card__avatar-img".concat(large ? ' user-card__avatar-img--large' : ''),
      "data-role": "user-avatar",
      alt: "user avatar",
      src: avatar,
      onError: function onError(e) {
        e.preventDefault();
        onAvatarErr(id, "Failed to load avatar for user ".concat(id));
        return false;
      }
    });
  } else if (initials) {
    avatarType = 'initials';
    avatarImg = /*#__PURE__*/React.createElement("span", {
      className: "user-card__initials"
    }, initials);
  }

  var avatarBlock = profileURL && !isLiu ? /*#__PURE__*/React.createElement("a", {
    className: "user-card__avatar".concat(large ? ' user-card__avatar--large' : ''),
    href: profileURL
  }, avatarImg) : /*#__PURE__*/React.createElement("span", {
    className: "user-card__avatar".concat(large ? ' user-card__avatar--large' : '')
  }, avatarImg);
  var nameBlock = profileURL && !isLiu ? /*#__PURE__*/React.createElement("a", {
    className: "user-card__username",
    href: profileURL
  }, displayName) : /*#__PURE__*/React.createElement("span", {
    className: "user-card__username user-card__username--no-href"
  }, displayName);
  return /*#__PURE__*/React.createElement("span", {
    className: "user-card user-card--".concat(avatarType)
  }, avatarBlock, nameBlock);
}

UserCard.displayName = "UserCard";
UserCard.propTypes = {
  id: PropTypes.number,
  avatar: PropTypes.string,
  initials: PropTypes.string,
  displayName: PropTypes.string,
  avatarErr: PropTypes.bool,
  large: PropTypes.bool,
  isLiu: PropTypes.bool,
  profileURL: PropTypes.string,
  onAvatarErr: PropTypes.func
};
export default UserCard;